<template>
  <v-row no-gutters>
    <v-col>
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
          <v-row no-gutters>
            <v-col class="d-flex pa-0">
              <v-autocomplete
                v-model="location_selected"
                :items="locations_list"
                item-text="name"
                item-value="_guid"
                label="All locations"
                dense
                solo
                clearable
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <!-- Divider and Header-->
                  <!-- Area item (group) -->
                  <template v-if="data.item._guid.type == TYPE_AREA">
                    <div class="select-drop-item-group__area">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                  <!-- Restaurant item (sub group) -->
                  <template v-else>
                    <div class="select-drop-item-sub_restaurant">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                </template>
              </v-autocomplete>

              <div style="margin-left:16px">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                      v-on:click:date="dateRangeSelect"
                    ></v-date-picker>

                    <v-divider></v-divider>

                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="menu_date_picker = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="menu_date_picker = false">Save</v-btn>
                    </v-card-actions> -->
                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>

              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:16px;"
              ></v-select>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          <div>
            <request-invoice-modal
              :periodDateFrom="date_range_selected && date_range_selected[0]"
              :periodDateTo="date_range_selected && date_range_selected[1]"
              :restaurantId="location_selected && location_selected.type == TYPE_RESTAURANT ? location_selected.id : void 0"
              :driverId="void 0"
              :disabled="!date_range_selected || !location_selected || location_selected.type != TYPE_RESTAURANT"
              :comission="invoice_comission"
              @invoiceGenerated="dateRangeSelect"
            ></request-invoice-modal>
          </div>
        </v-app-bar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel work area -->
        <v-card
          color="elevation-0"
          class="panel-invoices"
        >
          <v-card
            color="elevation-1"
            width="100%"
            class="time-sheet-table"
            style="margin-bottom:3px;"
            tile
          >
            <!-- headers -->
            <v-card
              color="elevation-1"
              class="time-sheet-table__header"
              style="margin-bottom:2px;"
              tile
            >
              <v-row no-gutters>
                <v-col cols="12" sm="2" md="2">Period</v-col>
                <v-col cols="12" sm="2" md="2">Number</v-col>
                <v-col cols="12" sm="4" md="4">Location</v-col>
                <v-col cols="12" sm="1" md="1">Сommission</v-col>
                <v-col cols="12" sm="3" md="3"></v-col>
              </v-row>
            </v-card>
            <!--/ headers -->
            <!-- body -->
            <v-card
              color="elevation-1"
              style="margin-bottom: 1px;"
              no-gutters
              tile
              class="time-sheet-table__line"
              v-for="item in invoicesSeached"
              :key="item.id"
             >
              <v-row align="stretch">
                <v-col cols="12" sm="2" md="2">{{item.period_date_from | headerDate}} to {{item.period_date_to | headerDate}}</v-col>
                <v-col cols="12" sm="2" md="2">{{item.invoice_number}}</v-col>
                <v-col cols="12" sm="4" md="4">{{getRestaurantNameByID(item.restaurant_id)}}, {{getAreaLabel(item.restaurant_id)}}</v-col>
                <v-col cols="12" sm="1" md="1">
                  1.5%
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-btn v-on:click="onViewInvocie(item)" :loading="localLoading">
                    <v-icon>mdi-file-document-outline</v-icon>&nbsp;View
                  </v-btn>
                  <v-btn v-on:click="onDownloadInvocie(item)" :loading="localLoading" class="ml-2">
                    <v-icon>mdi-file-document-outline</v-icon>&nbsp;Download
                  </v-btn>
                  <v-btn
                    depressed
                    class="red darken-4 ml-2"
                    :disabled="localLoading"
                    :loading="localLoading"
                    @click="onRemoveInvoice(item)">
                  <v-icon>mdi-close-circle</v-icon>&nbsp;Remove
                </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <!--/ body -->
          </v-card>
          <!--/ right panel work area -->

        </v-card>
      </div>
      <!--/ body -->
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import { TYPE_AREA, TYPE_RESTAURANT } from '../../store/areas';
import { DATE_RANGE_HELPERS,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH
       } from '../../store/shifts';

export default {
  name: "Invoices",
  data: () => ({
    // const list for template
    TYPE_AREA: TYPE_AREA,
    TYPE_RESTAURANT: TYPE_RESTAURANT,
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      { id: INTERVAL_MONTH, name: 'Month' },
    ],
    // ---
    localLoading: false,
    date_range_selected: null,
    period_date_selected: null,
    menu_date_picker: false,
    location_selected: void 0,
    interval_selected_id: INTERVAL_WEEK, // default week
    invoice_comission_default: void 0,
    invoice_comission: void 0,
  }),
  computed: {
    ...mapGetters({
      locations_list: 'locations',
      area_list: 'areas',
      restaurant_list: 'restaurants',
      invoices_list: 'invoices',
      options: 'options',
    }),
    restaurantListSearched() {
      if (!this.$data.location_selected) {
        return this.restaurant_list;
      }

      if (this.$data.location_selected.type == TYPE_AREA) {
        // filter by list of restaurants
        return _.filter(this.restaurant_list, p => p.area_id == this.$data.location_selected.id);
      } else if (this.$data.location_selected.type == TYPE_RESTAURANT) {
        // filter by one restaurant
        let restaurant = _.find(this.restaurant_list, p => p.id == this.$data.location_selected.id)
        if (restaurant) {
          return [restaurant];
        }
        return [];
      }

      return this.restaurant_list;
    },
    invoicesSeached() {
      let result = this.invoices_list;

      if (this.$data.location_selected !== void 0) {
        let restaurant_ids = _.map(this.restaurantListSearched, p => +p.id);
        result = _.filter(result, p => restaurant_ids.indexOf(+p.restaurant_id) !== -1);
      }

      result = _.orderBy(result, p => p.period_date_from);

      return result;
    }
  },
  watch: {
    period_date: function(period_date_new) {
      if (this.$data.period_date_selected != period_date_new) {
        this.$data.period_date_selected = period_date_new;
      }
    },
    location_selected: function(val) {
      this.invoice_comission = this.invoice_comission_default;
      if (val && val.type == TYPE_RESTAURANT) {
        let restaurant = _.find(this.restaurant_list, p => +p.id == +val.id)
        if (restaurant && restaurant.invoice_comission) {
          this.invoice_comission = restaurant.invoice_comission;
        }
      }
    }
  },
  mounted() {
    // moment.locale(['ru', 'en']);
    // aync load data
    Promise.all([
      this.$store.dispatch('fetchLocations'),
      this.$store.dispatch('fetchOptions'), // restaurants_standard_invoice_comission
    ]).then(() => {
      // fill example data
      let current_date = moment();
      // this.$data.interval_selected_id = this.$data.interval_list[1].id; // 1 - one week
      this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];

      // setup default comission
      let invoice_comission_default = _.find(this.options, p => p.okey == 'restaurants_standard_invoice_comission');
      if (invoice_comission_default && invoice_comission_default.ovalue) {
          this.invoice_comission_default = invoice_comission_default.ovalue;
      }

      this.dateRangeSelect();
    });
  },
  methods: {
    dateRangeSelect: async function() {
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);

      // fetch shifts from server
      await Promise.all([
        this.$store.dispatch('fetchInvoices', {
          period_date_from: this.$data.date_range_selected[0],
          period_date_to: this.$data.date_range_selected[1],
          // with_timesheet: '1'
        }),
      ]);
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
        // let date_to_shift_start = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        // let date_to_shift_end = moment(this.$data.date_range_selected[1], "YYYY-MM-DD");
        // if (date_to_shift_start < current_day && current_day < date_to_shift_end) {
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
        // } else {
        //   this.$data.date_range_selected = [date_to_shift_start.format("YYYY-MM-DD"), null];
        // }
      }

      Vue.nextTick(() => {
        this.dateRangeSelect();
      });
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'day');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    getAreaLabel: function(restaurant_id) {
      let restaurant = _.find(this.restaurant_list, p => +p.id == +restaurant_id);
      if (!restaurant) {
        return '-'; // impossible
      }

      let area = _.find(this.area_list, p => +p.id == +restaurant.area_id);
      if (!area) {
        return '-'; // impossible
      }

      return area.name;
    },
    // -- helpers:
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getPeriodDateText: function (period_date_selected) {
      return moment(period_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    getRestaurantNameByID: function(restaurant_id) {
      let resturant = _.find(this.restaurant_list, p => +restaurant_id == +p.id);
      if (!resturant) {
        return '-';
      }

      return resturant.name;
    },
    onDownloadInvocie: function(invoice) {
      this.localLoading = true;
      this.$store.dispatch('downloadInvoice', {
          id: invoice.id,
          invoice_number: invoice.invoice_number,
          period_date_from: invoice.period_date_from,
          period_date_to: invoice.period_date_to
      }).then(() => {
          //
      }).finally(() => {
          this.localLoading = false;
      });
    },
    onViewInvocie: function(invoice) {
      this.localLoading = true;
      this.$store.dispatch('viewInvocie', {
          id: invoice.id,
          // invoice_number: invoice.invoice_number,
          // period_date_from: invoice.period_date_from,
          // period_date_to: invoice.period_date_to
      }).then(() => {
          //
      }).finally(() => {
          this.localLoading = false;
      });
    },
    onRemoveInvoice: function(invoice) {
      this.localLoading = true;

      this.$store.dispatch('removeInvoice', invoice)
      .then(() => {
        //
      }).catch(error => {
          if(error && error.response && error.response.data && error.response.data.id) {
              alert(error.response.data.id[0]);
          }
      }).finally(() => {
          this.localLoading = false;
      });
    }
  },
  filters: {
    headerDate: function (date) {
      return moment(date, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
  },
}
</script>

<style scoped>
  .menu-date__picker {
    padding-left: 12px;
    margin-top: -22px;
    padding-right: 12px;
  }

  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }

  .menu-interval-changer {
    max-width: 120px; padding-top: 2px;
  }

  .menu-select__area {
    width: 300px;
  }
</style>

<style>
  .panel-invoices {
    width: 100%;
    overflow-x:auto;
    padding-bottom:20px;
    margin-top: 47px;
  }

  /* restore overloaded style */
  .multiselect__content-wrapper > ul.multiselect__content {
    padding-left: 0px;
  }
</style>
